import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { Route } from 'react-router';
import { ConnectedRouter } from 'connected-react-router';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import 'abortcontroller-polyfill/dist/polyfill-patch-fetch';
import ElementQueries from 'css-element-queries/src/ElementQueries';
import 'semantic-ui-css/semantic.min.css';
import historyService from 'common/services/HistoryService';
import 'common/styles/generic/global.scss';
import 'common/styles/responsive/responsive.scss';
import 'common/styles/generic/accessibility.scss';
import { asyncImport, AsyncImport, setFeatureForAppCallback } from 'common/services/ComponentLoaderService';
import { FeatureNamespace } from 'common/services/featureService';

import initServices from './initServices';
import App from './components/App';

import storeManager from './store';
// responsive elements
import './styles/responsive/responsive.scss';

ElementQueries.listen();

initServices();

setFeatureForAppCallback((featureNamespace: string, featureName: string): AsyncImport => {
    switch (featureNamespace) {
    case FeatureNamespace.COMMON:
        return asyncImport(import(`common/features/${featureName}`));
    case FeatureNamespace.GRADING:
        return asyncImport(import(`grading/src/features/${featureName}`));
    default:
        return undefined;
    }
});

const container = document.getElementById('wrapper');
const root = createRoot(container);
root.render(
    <Provider store={storeManager.getStore()}>
        <DndProvider backend={HTML5Backend}>
            <ConnectedRouter history={historyService.getHistory()}>
                <Route path="/" component={App} />
            </ConnectedRouter>
        </DndProvider>
    </Provider>
);
